var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.question)?_c(_vm.type,{tag:"component",attrs:{"question":_vm.question,"questionData":_vm.questionData,"selected":_vm.selected,"onAnswer":_vm.updateAnswer}}):_vm._e(),_vm._v(" "),(_vm.valid)?_c('button',{staticClass:"next-button",class:{
        invisible: !_vm.valid
    },on:{"click":_vm.submitAnswer}},[_vm._v("\n      "+_vm._s(_vm.submitText)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }